import { LuneThemeNew, Text } from '@lune-fe/lune-ui-lib'
import { SxProps } from '@mui/material'
import Box from '@mui/material/Box'
import { FC, ReactNode } from 'react'

import { middleEllipsize } from 'views/CalculateEmissions/Tables/ImportsTable/ImportTypeChip'

interface ExtraInfoChipProps {
    label: string
    icon: ReactNode
    /**
     * Background color for the chip (applied with 30% opacity).
     * Accepts hex color format
     * When not provided, defaults to `palette.Grey400`.
     */
    color?: string
    sx?: SxProps
}
const { palette } = LuneThemeNew

export const ExtraInfoChip: FC<ExtraInfoChipProps> = ({ label, color, sx, icon }) => {
    return (
        <Box
            title={label}
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 1 / 2,
                px: 1,
                py: 1 / 2,
                borderRadius: '100px',
                backgroundColor: (color || palette.Grey400) + '30', // 30% opacity
                lineHeight: 1,
                whiteSpace: 'nowrap',
                svg: {
                    height: '16px',
                    width: '16px',
                },
                ...sx,
            }}
        >
            {icon}
            <Text
                variant={'body3'}
                sx={{
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                }}
            >
                {middleEllipsize(label, 30)}
            </Text>
        </Box>
    )
}

export default ExtraInfoChip
